const key = "add-online-engine";

const applicable = (resp) => {
	return resp.config.url.match(/api\/forms\/[0-9]*$/);
};

const ruleJson = () => ({
	"Id": 1,
	"Title": "App must be online to perform this action",
	"Operator":
	{
		"Id": 2,
		"Code": "OR",
		"Name": "Or"
	},
	"Engine":
	{
		"Id": 1,
		"Code": "ENVIRONMENT",
		"Name": "Environment"
	},
	"Conditions":
	[
		{
			"Id": 1,
			"Operator": {
				Id: 2,
				Code: "ISONLINE",
				Name: "Is the device online"
			},
			"Value": true
		}
	],
	"Triggers":
	[
		{
			"Operator":
			{
				"Id": 1,
				"Code": "BLOCKSAVE",
				"Name": "Block Saving"
			},
			"Type":
			{
				"Id": 1,
				"Code": "VALIDATION",
				"Name": "Validation"
			}
		}
	]
});

const modify = (resp) => {
	if(!resp.data.Data?.Rules) {
		return;
	}

	const ruleWithNoEngine = ruleJson();
	resp.data.Data.Rules.push(ruleWithNoEngine);
};

export const addOnlineEngine = [key, applicable, modify];